module.exports = __webpack_public_path__ + "img/270.a7f36df9.png";